import React from "react";

const SettingsData = () => {
  return <div>SettingsData</div>;
};

export default SettingsData;
